<rask-container-block>
  <ng-container header>{{texts.fordelningsmatris}}</ng-container>
  <div class="row ps-2">
    <rask-label class="col-12 col-lg-12 m-0">
      {{texts.teckenforklaringDiameter | raskStringFormat:produktspecifikation.diaToppMin:produktspecifikation.diaToppMax}}
    </rask-label>
    <rask-label class="col-12 col-lg-12 m-0">
      {{texts.teckenforklaringLangd | raskStringFormat:produktspecifikation.langdgransMin:produktspecifikation.langdgransMax}}
    </rask-label>
  </div>
  @if (!displayMatris) {
    <div class="row">
      <rask-span class="col-12 col-lg-12 warning-text">{{texts.showFordelningsmatrisHelpText}}</rask-span>
    </div>
  }
  @if (displayMatris) {
    <div class="row">
      <rask-matris
        class="col-12"
        [produktspecifikation]="produktspecifikation"
        [form]="form">
      </rask-matris>
    </div>
  }
  <ng-container footer></ng-container>
</rask-container-block>
